module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback6-9d0f19c1c4130f5b83ae935d113b073a.jpg";